import moment from 'moment'
import { createSelector } from 'reselect'
import { RootState } from '../store'

const getUtilityData = (state: RootState) => state.utilityDetails.data
const getWellUtilityData = (state: RootState) => state.utilityDetails.wellData
const getLoading = (state: RootState) => state.utilityDetails.loading
const getShowDrawer = (state: RootState) => state.utilityDetails.showDrawer

const makeUtility = createSelector(getUtilityData, (data) => {
  const { MIN_VIOL_DATE = '', MAX_VIOL_DATE = '', CONTAMINANT_VIOLS = [] } = data

  const minViolDate = MIN_VIOL_DATE ? moment.unix(Number(MIN_VIOL_DATE) / 1e9).format('YYYY') : ""
  const maxViolDate = MAX_VIOL_DATE ? moment.unix(Number(MAX_VIOL_DATE) / 1e9).format('YYYY') : ""
  const DATA_AVAILABLE = `${minViolDate}-${maxViolDate}`

  const makeContaminantViols = CONTAMINANT_VIOLS.map(contaminant => ({
  ...contaminant,           
    CONTAMINANT_TREATMENTS: contaminant.CONTAMINANT_TREATMENTS?.length 
      ? contaminant.CONTAMINANT_TREATMENTS 
      : ['None']
  })).sort((a,b)=>{
      if(a.VIOL_FIRST_REPORTED_DATE < b.VIOL_FIRST_REPORTED_DATE ) return 1
      if(a.VIOL_FIRST_REPORTED_DATE > b.VIOL_FIRST_REPORTED_DATE ) return -1
      return 0
  })

  return {
    ...data,
    DATA_AVAILABLE,
    CONTAMINANT_VIOLS: makeContaminantViols
  }
})

const makeContaminantViolCount = createSelector(getUtilityData,(data)=>{
  return data.CONTAMINANT_VIOLS_COUNT || 0
})


export const UtilityDetailSelector = {
  makeUtility,
  getLoading,
  getShowDrawer,
  getWellUtilityData,
  makeContaminantViolCount,
}
